import 'isomorphic-fetch';
import queryString from 'query-string';
import config from '../utils/config';

const storyblokMiddleware = () => (next) => (action) => {
  if (!action.story) return next(action);

  next({ type: `${action.type}_REQUEST` });

  const { storyblokHost, storyblokApiKey: token } = config;
  const { path } = action.story;
  const spacesUrl = `${storyblokHost}/v1/cdn/spaces/me?${queryString.stringify({ token })}`;
  const storyUrl = (version) =>
    `${storyblokHost}/v1/cdn/stories/${path}?${queryString.stringify({
      token,
      cv: version,
    })}`;

  const handleResponseOrReject = (response) => {
    if (!response.ok) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        data: { message: response.statusText },
        status: response.status,
      });
    }

    return response.json();
  };

  /**
   * The sequence for Storyblok API requests is as follows:
   *
   * 1. Hit the main spaces URL to request the most recent spaces.version
   *    identifier; this is needed to ensure we’re getting the most recent
   *    version of a given story (i.e. it’s a cachebusting mechanism).
   * 2. Once we have the spaces.version, include that in the second fetch
   *    request against the actual Story path provided by the action.
   *
   * This does mean we make two API calls for every Storyblok action, and we
   * could probably benefit from some sort of caching here longterm.
   */
  return fetch(spacesUrl)
    .then(handleResponseOrReject)
    .then(({ space }) => fetch(storyUrl(space.version)))
    .then(handleResponseOrReject)
    .then((result) => {
      if (typeof result !== 'undefined') {
        return {
          type: `${action.type}_SUCCESS`,
          payload: result,
        };
      }
      return {
        type: `${action.type}_FAILURE`,
        error: {
          status: 404,
          message: `Story Not Found "${path}"`,
        },
      };
    })
    .catch((error) => ({
      type: `${action.type}_FAILURE`,
      payload: {
        error: {
          status: error.status,
          message: `Story Not Found "${path}"`,
        },
      },
    }))
    .then(next);
};

export default storyblokMiddleware;
